'use client';
import type { ReactNode, Dispatch, SetStateAction } from 'react';
import React, { createContext, useContext, useState } from 'react';

type VideoContextType = {
    isMuted: boolean;
    setIsMuted: Dispatch<SetStateAction<boolean>>;
};

const VideoContext = createContext<VideoContextType | undefined>(undefined);

export const useMutedState = () => {
    const [isMuted, setIsMuted] = useState(true);
    const context = useContext(VideoContext);
    if (!context) {
        return { isMuted, setIsMuted };
    }
    return context;
};

export const VideoProvider = ({ children }: { children: ReactNode }) => {
    const [isMuted, setIsMuted] = useState(true);

    return <VideoContext.Provider value={{ isMuted, setIsMuted }}>{children}</VideoContext.Provider>;
};
